/* istanbul ignore file */
import React from 'react';
import { Option, Dropdown } from 'framework/form';

interface ArtifactStorageTypeDropdownProps {
  source: string;
  isVisible?: boolean;
  options: Option[];
}

const ArtifactStorageTypeDropdown = ({ options, ...props }: ArtifactStorageTypeDropdownProps) => {
  return <Dropdown {...props} options={options} placeholder="Choose Artifact Type" />;
};

export default ArtifactStorageTypeDropdown;
